export enum SettingType {
    GlobalSetting,
    ModuleSetting,
    ComponentSetting,
}